import { render, staticRenderFns } from "./PopupTip.vue?vue&type=template&id=98a4ed0e&scoped=true&"
import script from "./PopupTip.vue?vue&type=script&lang=js&"
export * from "./PopupTip.vue?vue&type=script&lang=js&"
import style0 from "./PopupTip.vue?vue&type=style&index=0&id=98a4ed0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a4ed0e",
  null
  
)

export default component.exports